import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-form-input-currency',
  templateUrl: './form-input-currency.component.html',
  styleUrls: ['./form-input-currency.component.sass']
})
export class FormInputCurrencyComponent implements OnInit {
  @ViewChild('currencyInput') currencyInput!: ElementRef;
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() required: boolean = false;
  @Input() formName: any;
  @Input() control: FormControl = new FormControl();
  @Input() error: boolean = false;
  @Input() errorMessage: string = '';
  @Input() htmlId: string = '';
  @Input() min: string = '';
  @Input() max: string = '';
  @Input() currency: any[] = [];
  @Input() readonly: boolean = false;
  @Input() toolTipMessage: string = '';

  selectedCurrency: any = null;

  constructor() { }

  ngOnInit() {
    // Set default currency if available
    if (this.currency && this.currency.length > 0) {
      this.selectedCurrency = this.currency[0];
    }

    // Initialize the control with default value if control has one
    if (this.control.value) {
      // Handle existing currency value format
      if (typeof this.control.value === 'object' && this.control.value.CurrencyId && this.control.value.Value) {
        // Value is already in correct format, keep it
        this.control.setValue(this.control.value);
      } else if (typeof this.control.value === 'string' || typeof this.control.value === 'number') {
        // Value is just a number/string, convert to currency format
        if (this.selectedCurrency && this.control.value) {
          const currencyValue = {
            CurrencyId: this.selectedCurrency.id,
            Value: this.control.value.toString()
          };
          this.control.setValue(currencyValue);
        }
      }
    }

    // Add validators based on min/max values
    const validators = [];
    if (this.required) {
      validators.push(Validators.required);
    }
    if (this.min !== '') {
      validators.push(Validators.min(Number(this.min)));
    }
    if (this.max !== '') {
      validators.push(Validators.max(Number(this.max)));
    }

    // Update control validators
    this.control.setValidators(validators);
    this.control.updateValueAndValidity();
  }

  onInputChange(event: any) {
    const value = event.target.value;

    // Remove any non-numeric characters except decimal point
    const numericValue = value.replace(/[^\d.]/g, '');

    // Ensure only one decimal point
    const parts = numericValue.split('.');
    let formattedValue;
    if (parts.length > 2) {
      formattedValue = parts[0] + '.' + parts.slice(1).join('');
    } else {
      formattedValue = numericValue;
    }

    // Store the value in the correct format for currency fields
    if (this.selectedCurrency && formattedValue) {
      const currencyValue = {
        CurrencyId: this.selectedCurrency.id,
        Value: formattedValue
      };
      this.control.setValue(currencyValue);
    } else {
      this.control.setValue(formattedValue);
    }
  }

  getCurrencySymbol(): string {
    return this.selectedCurrency?.symbol || '€';
  }

  getCurrencyName(): string {
    return this.selectedCurrency?.name || 'Euro';
  }

  getDisplayValue(): string {
    if (this.control.value) {
      if (typeof this.control.value === 'object' && this.control.value.Value) {
        return this.control.value.Value;
      } else if (typeof this.control.value === 'string' || typeof this.control.value === 'number') {
        return this.control.value.toString();
      }
    }
    return '';
  }
}
